import { ReactElement, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import Button from '@/components/Button'
import SectionTitle from '@/components/SectionTitle'

import { BlogPropType } from '@/propTypes'
import { ReactComponent as Group44 } from '@/svg/decorators/group-44.svg'
import { ReactComponent as Group379 } from '@/svg/decorators/group-379.svg'

import Item from '@/features/landing/components/Blog/Item'

import Container from './style'

interface Props {
  blogLink: string
  items: BlogInterface[]
  style?: CSSProperties
  className?: string
  id?: string
}

function Blog({ id, className, style, items, blogLink }: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      <div className="decorator-container">
        <Group44 id="group-44" />
        <Group379 id="group-379" />
      </div>
      <div className="container">
        <SectionTitle className="title">
          <span>PDPA Blog</span>
          <span>ติดตามบทความ ความรู้เกี่ยวกับ PDPA เพิ่มเติม ที่นี่...</span>
        </SectionTitle>
        <section className="grid-container">
          {items.slice(0, 4).map((blog: BlogInterface) => (
            <Item key={blog.id} blog={blog} />
          ))}
        </section>
        <a
          href={blogLink}
          target="_blank"
          rel="noreferrer"
          className="all-blog"
        >
          <Button isPrimary={false} usePrimaryColor={false}>
            อ่านบทความอื่นๆ
          </Button>
        </a>
      </div>
    </Container>
  )
}

Blog.propTypes = {
  blogLink: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(BlogPropType).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

Blog.defaultProps = {
  className: '',
}

export default memo(Blog)
